import React, { useState, useEffect } from "react";
import "./TextInput.css";
import { strings } from "../../translations/strings";
import ArrowRight from "../../assets/icons/RightArrowWhite.svg";

const lineHeight = 24;
const maxCharacters = 4096;

const TextInput = ({ colors, value, handleInputChange, onPressButton }) => {
  const [numberOfRows, setNumberOfRows] = useState(1);

  const handleChange = (event) => {
    handleInputChange(event?.target?.value);
    const newNumberOfRows = Math.ceil(
      (event?.target?.scrollHeight - 8) / lineHeight,
    );
    setNumberOfRows(newNumberOfRows);
  };

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--background-color",
      colors.componentBackground,
    );
  }, [colors.componentBackground]);

  return (
    <div className="text-input-container">
      <textarea
        className="text-input"
        placeholder={strings.idea_validator_input_placeholder}
        onChange={handleChange}
        style={{ color: colors.primaryText }}
        rows={numberOfRows}
        maxLength={maxCharacters}
        value={value}
      />
      <div className="text-input-button" onClick={onPressButton}>
        <img alt="Arrow" src={ArrowRight} draggable={false} />
      </div>
    </div>
  );
};
export default TextInput;
